export default __webpack_public_path__ + "static/media/sp-white.06c92e5b.svg";